'use client';
import { useRef } from 'react';
import { submitJson, submitUrlencoded } from './contentTypes';
import { HTTP_METHOD } from './contentTypes/json';

export interface FormProps {
    action: string;
    method: HTTP_METHOD;
    contentType: 'json' | 'urlencoded' | 'x-www-form-urlencoded';
    children: React.ReactNode;
    onBeforeSubmit?: (data: FormData) => FormData;
    onSubmit?: (event: React.FormEvent, data: FormData) => boolean;
    onChange?: React.FormEventHandler | undefined;
    onSuccess?: (response: Response) => void;
    onFail?: (error: Error | Response) => void;
    novalidate?: boolean;
    dataCy?: string;
}
export function Form(props: FormProps): React.JSX.Element {
    const form = useRef<HTMLFormElement | null>(null);
    function submit(event: React.FormEvent) {
        event.preventDefault();
        if (form.current) {
            // TO DO: possibly refactor this to use refs instead of querySelectorAll
            const allFields = Array.from(form.current.querySelectorAll('[required]'));
            if (allFields.length > 0) {
                allFields.forEach((a) => {
                    const fields = a as HTMLInputElement;
                    if (!fields.value) {
                        fields.ariaInvalid = 'true';
                    }
                });
            }
            const allInvalidFields = Array.from(
                form.current.querySelectorAll('input[aria-invalid]:not([aria-invalid="false"])'),
            );
            if (allInvalidFields.length > 0) {
                const firstInvalidField = allInvalidFields[0] as HTMLInputElement;
                firstInvalidField.focus();
            }
            let data = new FormData(form.current);
            if (props.onBeforeSubmit) {
                data = props.onBeforeSubmit(data);
            }
            if (props.onSubmit) {
                const cont = props.onSubmit(event, data);
                if (!cont) {
                    return;
                }
            }

            if (props.contentType === 'json') {
                submitJson(props.action, props.method, data)
                    .then((response) => {
                        if (props.onSuccess) {
                            props.onSuccess(response);
                        }
                    })
                    .catch((error) => {
                        if (props.onFail) {
                            props.onFail(error);
                        }
                    });
            } else if ((props.contentType === 'urlencoded') || (props.contentType === 'x-www-form-urlencoded')) {
                submitUrlencoded(props.action, props.method, data)
                    .then((response) => {
                        if (response.status < 400) {
                            if (props.onSuccess) {
                                props.onSuccess(response);
                            }
                        } else {
                            if (props.onFail) {
                                props.onFail(response);
                            }
                        }
                    })
                    .catch((error) => {
                        if (props.onFail) {
                            props.onFail(error);
                        }
                    });
            }
        }
    }
    return (
        <form
            ref={form}
            action={props.action}
            method={props.method}
            noValidate={props.novalidate}
            onSubmit={submit}
            onChange={props.onChange}
            data-cy={props?.dataCy}
        >
            {props.children}
        </form>
    );
}
